import { useTranslation } from 'react-i18next'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { ConfigurationHeaderWrapper } from '../_components/configuration-header-wrapper.component'
import { TFollowup } from 'src/types/followup'
import FollowupCardList from 'src/components/followup-card-list/followup-card-list.component'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'

export default function ConfigurationFollowupsPage() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const { project } = useCurrentProject()

  return (
    <ConfigurationHeaderWrapper title={t('pages.configuration.manage-followups')}>
      <div className="c-pb-10">
        <FollowupCardList
          onClickOnCard={(followup: TFollowup) =>
            navigate(`/${project.id}/configuration/followups/${followup.id}`)
          }
          addFollowup={() => navigate(`/${project.id}/configuration/followups/add`)}
          addFollowupLabel={t('pages.configuration.followups.add-followup')}
        />
      </div>
    </ConfigurationHeaderWrapper>
  )
}
